<template>
  <div class="Image-upload-wrapper Image-upload mb-4">
    <div id="cover-croppie"></div>
    <div id="upload-wrapper">
      <div class="Modal">
        <div class="input-file">
          <input
            type="file"
            id="upload-cover-image"
            class="d-none"
            ref="upload-cover-image"
            @change="setUpFileUploader"
            accept="image/jpeg, image/png"
          >
        </div>
        <b-row class="upload-image-actions justify-content-center mb-4">
          <div class="d-flex justify-content-between w-75">
            <a class="btn btn-secondary" @click="$emit('onCancelUploadFile')">Cancelar</a>
            <a class="btn btn-secondary" @click="selectImage">
              <b-icon-upload />
            </a>
            <a class="btn btn-primary" @click="uploadFile">Actualizar</a>
          </div>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
import Croppie from 'croppie'
import { BIconUpload } from 'bootstrap-vue'

export default {
  name: 'ImageUpload',
  components: {
    BIconUpload
  },
  props: {
    coverImgUrl: {
      type: String,
      required: false,
      default: '/img/profile-background.png'
    },
    dispatch: {
      type: String,
      default: 'uploadTechnicianCoverImage'
    }
  },
  data () {
    return {
      image: null,
      croppie: null
    }
  },
  mounted () {
    this.$on('imageUploaded', function (imageData) {
      this.img = imageData
      this.croppie.destroy()
      this.setUpCroppie(imageData)
    })
    this.image = this.coverImgUrl
    this.setUpCroppie()

    this.$refs['upload-cover-image'].click()
  },
  methods: {
    setUpCroppie () {
      const el = document.getElementById('cover-croppie')
      const sizes = el.getBoundingClientRect()
      this.croppie = new Croppie(el, {
        viewport: { width: sizes.width - 20, height: 176 },
        boundary: { width: sizes.width, height: 200 },
        showZoomer: true,
        enableOrientation: false
      })
      this.croppie.bind({
        url: this.image
      })
    },
    setUpFileUploader (evt) {
      const files = evt.target.files || evt.dataTransfer.files
      if (!files.length) {
        return
      }

      this.createImage(files[0])
    },
    createImage (file) {
      // const image = new Image()
      const reader = new FileReader()
      const vm = this

      reader.onload = (e) => {
        vm.image = e.target.result
        vm.$emit('imageUploaded', e.target.result)
      }
      reader.readAsDataURL(file)
    },
    uploadFile () {
      this.croppie.result({
        type: 'canvas',
        size: 'original'
      })
        .then(response => {
          this.image = response
          let [type, data] = response.split(',')
          type = type.replace(';base64', '')
          const [, extension] = type.split('/')
          this.lockScreen()
          this.$store.dispatch(this.dispatch, { base64: data, extension: extension })
            .then((response) => {
              this.$emit('onChangeUploadFile')
            })
            .catch((error) => {
              console.log(error)
            })
        })
    },
    selectImage () {
      this.$refs['upload-cover-image'].click()
    }
  }
}
</script>

<style lang="less">
  .Image-upload {
    border-bottom: 1px solid white;
    .Modal {
      margin-top: 10px;
    }
  }
</style>
